import request from '@/utils/request'
import host from '@/api/base/host'

const path = host.path('dev', { module: 'order', dev: 'v2' })
export default {
  postReceive(data) {
    //preClaim
    const url = path('order/h5/preClaim')
    return request({ url: url, method: 'post', data })
  }
}
